import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { RepaymentOption } from "../../../../re-payment.interface";

@Component({
    selector: "web-emi-payment",
    templateUrl: "./emi-payment.component.html",
    styleUrls: ["./emi-payment.component.scss"],
})
export class EmiPaymentComponent {
    summaryDetails: any = {};
    repaymentOption = RepaymentOption;

    constructor(
        public dialog: MatDialog,
        private dialogRef: MatDialogRef<EmiPaymentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data && Object.keys(data).length > 0) {
            this.summaryDetails = data;
        }
    }

    proceed() {
        this.dialogRef.close({
            data: true,
        });
    }

    closeDialog() {
        this.dialogRef.close({
            data: false,
        });
    }
}
